import { Component } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";

@Component({
	selector: "app-modal-danger",
	templateUrl: "./modal-danger.component.html",
	styleUrls: ["./modal-danger.component.scss"],
	standalone: false
})
export class ModalDangerComponent {
	public onClose = new Subject<boolean>();
	public title = "Algo está acontecendo que precisa de atenção";
	public description = "";
	public btnSecondaryLabel = "";
	public btnDangerLabel = "";

	constructor(public bsModalRef: BsModalRef) {}

	confirm(): void {
		this.onClose.next(true);
		this.bsModalRef.hide();
	}

	cancel(): void {
		this.onClose.next(false);
		this.bsModalRef.hide();
	}
}
